import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeFournitures } from '../models/TypeFournitures';

@Component({
  selector: 'app-type-fournitures',
  templateUrl: './type-fournitures.component.html'
})
export class TypeFournituresComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeFournitures';
  @Input() parentForm: FormGroup;
  @Input() typeFournitures: TypeFournitures;

  constructor() {
  }

  public ngOnInit() {
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}
